(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   * Service for running a job using the jobs API.
   * promise resolves when job is finished.
   */
  factory('Job', ['Logger', '$http', '$timeout', '$q', function (Logger, $http, $timeout, $q) {
    return {
      run: function run(scope, url, jobName, params, refreshDelay, hideDelay) {
        return function (functionParams) {
          refreshDelay = refreshDelay || 1000;
          hideDelay = hideDelay || 5000;
          params = params || {};
          delete scope[jobName + 'Error'];
          angular.extend(params, functionParams);
          var options = null;
          if (Object.keys(params).length !== 0) {
            options = {
              params: params
            };
          }
          function handleError(response) {
            delete scope[jobName];
            Logger.error("Error running job, response status " + response.status);
            scope[jobName + 'Error'] = "There was an error running the job: " + "<br/>" + response.data.message + "<br/>" + response.data.exceptionMessage;
          }
          var deferred = $q.defer();
          $http.post(url, null, options).then(function (createResponse) {
            var jobLocation = createResponse.headers('location');
            (function getJobStatus(response) {
              var delay = 0;
              if (response) {
                delay = refreshDelay;
                scope[jobName] = response.data;
                var status = scope[jobName].status;
                if (status !== "running" && status !== "submitted") {
                  if (status === "aborted") {
                    scope[jobName + 'Error'] = scope[jobName].messages;
                  }
                  $timeout(function () {
                    scope[jobName] = null;
                    deferred.resolve();
                  }, hideDelay);
                  return;
                }
              }
              $timeout(function () {
                $http.get(jobLocation).then(getJobStatus, handleError);
              }, delay);
            })();
          }, handleError);
          return deferred.promise;
        };
      }
    };
  }]);
})();
